export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/branding_services.51acac3.svg";